import * as S from './Styles';

export interface TagProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {}

const Tag = ({ ...rest }: TagProps) => {
  return <S.Tag {...rest} />;
};

export default Tag;
